import { Backdrop, CircularProgress } from "@mui/material";

/** @deprecated Import from `@monthly/ui` instead
 * @example
 * import { PageLoader } from '@monthly/ui' */
export function PageLoader({ open }: { open: boolean }) {
  return (
    <Backdrop
      sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
